import { defineAsyncComponent } from "vue";

const ImgSlider = defineAsyncComponent(() => import("./img-slider.vue"));

export default {ImgSlider};